import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const FullPageWrapper = styled(Box)(({ children, theme, ...props }) => ({
  width: '100%',
  height: '100vh',
  overflow: 'hidden',
  ...props,
}));

const FullPageFlexBox = styled(FullPageWrapper)(
  ({ children, theme, ...props }) => ({
    display: 'flex',
    ...props,
  })
);

const FlexBox = styled(Box)(({ children, theme, ...props }) => ({
  display: 'flex',
  ...props,
}));

const ColumnFlexBox = styled(FlexBox)(({ children, theme, ...props }) => ({
  flexDirection: 'column',
  ...props,
}));

const FullSizeFlexBox = styled(FlexBox)(({ children, theme, ...props }) => ({
  width: '100%',
  height: '100%',
  ...props,
}));

const FullSizeColumn = styled(ColumnFlexBox)(
  ({ children, theme, ...props }) => ({
    width: '100%',
    height: '100%',
    ...props,
  })
);

const FullSizeCenteredColumn = styled(FullSizeColumn)(
  ({ children, theme, ...props }) => ({
    justifyContent: 'center',
    ...props,
  })
);

const CenteredFlexBox = styled(FlexBox)(({ children, theme, ...props }) => ({
  alignItems: 'center',
  ...props,
}));

const CenteredColumnFlexBox = styled(ColumnFlexBox)(
  ({ children, theme, ...props }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    ...props,
  })
);

const FullSizeCenteredFlexBox = styled(FullSizeFlexBox)(
  ({ children, theme, ...props }) => ({
    alignItems: 'center',
    ...props,
  })
);

export {
  FlexBox,
  ColumnFlexBox,
  FullSizeFlexBox,
  CenteredFlexBox,
  CenteredColumnFlexBox,
  FullSizeCenteredFlexBox,
  FullPageWrapper,
  FullPageFlexBox,
  FullSizeColumn,
  FullSizeCenteredColumn,
};
